import React, { useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';

const ImageModal = ({ photos, currentIndex, onClose, onNavigate }) => {
  const currentPhoto = photos[currentIndex];
  const isFirstPhoto = currentIndex === 0;
  const isLastPhoto = currentIndex === photos.length - 1;

  // Handle keyboard navigation
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    } else if (e.key === 'ArrowLeft' && !isFirstPhoto) {
      onNavigate(currentIndex - 1);
    } else if (e.key === 'ArrowRight' && !isLastPhoto) {
      onNavigate(currentIndex + 1);
    }
  }, [onClose, onNavigate, currentIndex, isFirstPhoto, isLastPhoto]);

  // Add keyboard event listener
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [handleKeyDown]);

  // Handle click outside to close
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('image-modal-overlay')) {
      onClose();
    }
  };

  return (
    <div className="image-modal-overlay" onClick={handleOverlayClick}>
      <div className="image-modal-content">
        {/* Close button */}
        <button
          className="modal-close-btn"
          onClick={onClose}
          aria-label="Zavřít"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        {/* Previous button */}
        {!isFirstPhoto && (
          <button
            className="modal-nav-btn modal-prev-btn"
            onClick={() => onNavigate(currentIndex - 1)}
            aria-label="Předchozí fotografie"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
        )}

        {/* Image with caption */}
        <div className="modal-image-wrapper">
          <img
            src={currentPhoto.image}
            alt={currentPhoto.caption}
            className="modal-image"
          />
          <div className="modal-image-caption">
            {currentPhoto.caption}
          </div>
        </div>

        {/* Next button */}
        {!isLastPhoto && (
          <button
            className="modal-nav-btn modal-next-btn"
            onClick={() => onNavigate(currentIndex + 1)}
            aria-label="Další fotografie"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ImageModal;
